/**
 * Compiles the raw publication folder hierarchy (the `IStoryFolder`-shaped tree
 * returned by `usePublicationFoldersHierarchy`) into the `IStoriesFolder` tree
 * the section UI renders.
 *
 * Extracted verbatim from the `compileNodes` transform that lived inside
 * `selectPublicationFolderStructure` (publicationViewSelectors.ts) — and the
 * inline copy in PublicationView.tsx. Behavior is identical: `id`, `title`→
 * `displayName`, `order` carry over, `subFolders` recurse into `children`.
 *
 * Input stays `any` (as the original did) — the raw nodes carry an `order`
 * field that is not on the `IStoryFolder` type.
 */

import { IStoriesFolder } from '../../../../../types';

export const compilePublicationFolderNodes = (nodeList: any): IStoriesFolder[] => {
  if (!nodeList) return;
  return (
    nodeList &&
    nodeList.map((node) => {
      const newNode: any = {
        id: null,
        displayName: null,
        children: null,
        toggled: false,
        order: 0
      };
      newNode.id = node.id;
      newNode.displayName = node.title;
      newNode.order = node.order;
      if (node.subFolders && node.subFolders.length > 0) {
        newNode.children = compilePublicationFolderNodes(node.subFolders);
      }
      return newNode;
    })
  );
};
